import * as React from 'react';
import { SVGProps } from 'react';

const SvgFirstAidOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)" stroke="currentColor">
      <path d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" strokeWidth={2} />
      <path d="M12.5 11v.5H15a.5.5 0 0 1 0 1h-2.5V15a.5.5 0 0 1-1 0v-2.5H9a.5.5 0 0 1 0-1h2.5V9a.5.5 0 0 1 1 0v2Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFirstAidOutlined;
